import styled from 'styled-components';

const ExpandIcon = styled.div<{ $clicked?: boolean }>`
    transform: ${props => (props.$clicked ? 'rotate(180deg)' : 'rotate(0deg)')};
    transform-origin: center center;
    margin-left: 4px;
`;

export default ExpandIcon;
